export default defineNuxtPlugin(async () => {
	// Load user info before any route navigation
	// This ensures the role check middleware has access to user data
	const userInfoStore = useUserInfoStore()

	if (import.meta.client) {
		try {
			const res = await $fetch("/api/user")
			if (res != null) {
				userInfoStore.setUserInfo(res)
			}
		} catch (error) {
			console.error("Failed to load user info:", error)
		}
	}
})
